const sleep = (msec) => new Promise((resolve) => setTimeout(resolve, msec))

export { sleep as default }
